import * as exUtils from './utils';

// ----------------------------------------------------------------------------

declare global {
    interface HTMLElement {
        showModal(config?: Record<string, any>): void;
        hideModal(config?: Record<string, any>): void;
        toggleModal(config?: Record<string, any>): void;
        disposeModal(config?: Record<string, any>): void;
    }
}

// ----------------------------------------------------------------------------

HTMLElement.prototype.showModal = function (config?: Record<string, any>): void {
    exUtils.show(this, config);
};

HTMLElement.prototype.hideModal = function (config?: Record<string, any>): void {
    exUtils.hide(this, config);
};

HTMLElement.prototype.toggleModal = function (config?: Record<string, any>): void {
    exUtils.toggle(this, config);
};

HTMLElement.prototype.disposeModal = function (config?: Record<string, any>): void {
    exUtils.dispose(this, config);
};
